// extracted by mini-css-extract-plugin
export var disabled = "styles-module--disabled--5205a";
export var link = "styles-module--link--5a64e";